import React from 'react';
import { Box } from '@mui/material';
import AdminCompanyEdit from './AdminCompanyEdit';
import AdminCompanyTracking from './AdminCompanyTracking';
import AdminCompanyPayments from './AdminCompanyPayments';
import AdminBotPanel from './AdminBotPanel';
import AdminHolidays from './AdminHolidays';
import AdminSystem from './AdminSystem';

function AdminContent({ content }) {
  return (
    <Box id="MainBody">
      {content === 0 && <AdminCompanyEdit />}
      {content === 1 && <AdminCompanyTracking />}
      {content === 2 && <AdminCompanyPayments />}
      {content === 4 && <AdminBotPanel />}
      {content === 5 && <AdminHolidays />}
      {content === 6 && <AdminSystem />}
    </Box>
  );
}

export default AdminContent;
